import ModalConfirmFinishPosition from './ModalConfirmFinishPosition'

export default ModalConfirmFinishPosition
